import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import MessengerFullscreen from "../../../components/MessengerFullscreen";
import MessengerFullscreenSkeleton from "../../../components/MessengerFullscreenSkeleton";
import { fetchConversationByIdQueryOptions } from "../../../services";

export const Route = createFileRoute("/_panel/_messenger/messenger/$id")({
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchConversationByIdQueryOptions(opts.params.id),
    ),
  pendingComponent: MessengerFullscreenSkeleton,
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  return (
    <div className="-m-4 h-[calc(100dvh-4rem)] overflow-hidden sm:-m-6 sm:mb-[-8rem] sm:h-dvh">
      <MessengerFullscreen conversationId={id} />
    </div>
  );
}
